import { Record } from 'immutable';
import { ICurrentOrLegacyReport, ILegacyReport } from '@opengov/reporting-types';

export const LegacyReport = Record<ILegacyReport>({
  id: null,
  entity_id: null,
  entity: null,
  coa_id: null,
  report_type: null,
  report_type_name: null,
  access_code: null,
  hidden: null,
  name: null,
  description: null,
  properties: null,
  coa_mask_id: null,
  created: null,
  updated: null,
  is_default: false,
  is_private: true,
  position: null,
  owner: null,
  visibility: null,
  is_geo_enabled: false
});

export const CurrentOrLegacyReport = Record<ICurrentOrLegacyReport>({
  id: null,
  name: null,
  legacyReportId: null,
  legacyReportType: null,
  description: null,
  version: 'v2',
  isPrivate: false,
  url: null,
  isGeoEnabled: false,
  isMultiDataset: false
});
